import React, { useState } from "react";

// Interactive phonetic heatmap with clickable cells
const DEFAULT_PHONEMES = [
  { label: "/θ/", word: "think", spanishGap: "diferente a 't'", score: 94 },
  { label: "/ð/", word: "weather", spanishGap: "difícil, no existe en español", score: 62 },
  { label: "/r/", word: "red", spanishGap: "menos vibrante que la R española", score: 88 },
  { label: "/æ/", word: "cat", spanishGap: "entre la 'a' y la 'e'", score: 71 },
  { label: "/ə/", word: "about", spanishGap: "vocal neutra, la más común", score: 58 },
  { label: "/ʃ/", word: "shore", spanishGap: "no confundir con la 'ch'", score: 82 },
  { label: "/tʃ/", word: "church", spanishGap: "similar a 'ch' española", score: 96 },
  { label: "/v/", word: "very", spanishGap: "labiodental, no 'b'", score: 74 },
  { label: "/ŋ/", word: "sing", spanishGap: "solo al final, no 'ng'", score: 68 },
  { label: "/z/", word: "zebra", spanishGap: "sonora, vibra la garganta", score: 79 },
  { label: "/h/", word: "house", spanishGap: "más suave que la 'j'", score: 91 },
  { label: "/w/", word: "water", spanishGap: "labial, entre 'g' y 'u'", score: 86 },
];

const cellColor = (score) => {
  if (score >= 90) return { bg: "rgba(114,40,200,0.14)", border: "rgba(114,40,200,0.28)", label: "Sólido" };
  if (score >= 75) return { bg: "rgba(114,40,200,0.06)", border: "#DEDAE2", label: "Aceptable" };
  return { bg: "rgba(30,25,36,0.04)", border: "#DEDAE2", label: "A trabajar" };
};

export const PhoneticHeatmap = ({ phonemes = DEFAULT_PHONEMES }) => {
  const [selected, setSelected] = useState(phonemes[1]);
  return (
    <div className="grid lg:grid-cols-[1fr_320px] gap-6">
      <div>
        <div className="grid grid-cols-3 sm:grid-cols-4 gap-2.5">
          {phonemes.map((p) => {
            const c = cellColor(p.score);
            const active = selected.label === p.label;
            return (
              <button
                key={p.label}
                onClick={() => setSelected(p)}
                data-testid={`heatmap-cell-${p.label}`}
                className="rounded-xl border p-3 text-left transition-colors"
                style={{
                  background: c.bg,
                  borderColor: active ? "#1E1924" : c.border,
                }}
              >
                <div className="flex items-baseline justify-between">
                  <div className="font-mono-num text-[18px] font-semibold" style={{ color: "#1E1924" }}>
                    {p.label}
                  </div>
                  <div className="font-mono-num text-[13px] tabular-nums" style={{ color: p.score >= 90 ? "#7228C8" : "#70667A" }}>
                    {p.score}%
                  </div>
                </div>
                <div className="text-[12px] mt-1 truncate" style={{ color: "#70667A" }}>
                  {p.word}
                </div>
              </button>
            );
          })}
        </div>
        <div className="flex items-center gap-4 mt-4 text-[12px]" style={{ color: "#70667A" }}>
          <span className="flex items-center gap-1.5">
            <span className="w-3 h-3 rounded" style={{ background: "rgba(114,40,200,0.14)" }} /> Sólido
          </span>
          <span className="flex items-center gap-1.5">
            <span className="w-3 h-3 rounded" style={{ background: "rgba(114,40,200,0.06)", border: "1px solid #DEDAE2" }} /> Aceptable
          </span>
          <span className="flex items-center gap-1.5">
            <span className="w-3 h-3 rounded" style={{ background: "rgba(30,25,36,0.04)", border: "1px solid #DEDAE2" }} /> A trabajar
          </span>
        </div>
      </div>
      <div className="wk-card p-6">
        <div className="wk-eyebrow mb-3">Fonema seleccionado</div>
        <div className="font-mono-num text-[42px] font-bold tracking-hero leading-none" style={{ color: "#1E1924" }}>
          {selected.label}
        </div>
        <div className="mt-2 text-[15px]" style={{ color: "#1E1924" }}>
          Ejemplo: <span className="font-semibold">{selected.word}</span>
        </div>
        <div className="mt-3 text-[13px] max-w-prose-tight leading-[1.6]" style={{ color: "#70667A" }}>
          {selected.spanishGap}
        </div>
        <div className="mt-5 p-4 rounded-lg" style={{ background: "#FAF9FB", border: "1px solid #DEDAE2" }}>
          <div className="text-[12px] uppercase tracking-[0.14em] mb-2" style={{ color: "#70667A" }}>
            Ejercicios sugeridos
          </div>
          <ul className="text-[13px] space-y-1.5" style={{ color: "#1E1924" }}>
            <li>· 3 minutos de <em>minimal pairs</em> con Sarah M.</li>
            <li>· Repetición guiada de 12 palabras clave</li>
            <li>· Grabación libre de 30 segundos y comparación</li>
          </ul>
        </div>
        <button
          className="wk-btn wk-btn-primary w-full mt-5"
          onClick={() => alert("Ejercicio simulado — se activará en Fase 1.")}
          data-testid="heatmap-practice-btn"
        >
          Practicar este fonema
        </button>
      </div>
    </div>
  );
};
